// Copyright (c) 2026 by Audere

import { Alert, AlertTitle } from "@mui/material";

export const WarningAlert: React.FC<{ message: string }> = ({ message }) => {
  return (
    <Alert severity="warning" role="alert">
      <AlertTitle>Warning: </AlertTitle>
      {message}
    </Alert>
  );
};
